import { StringConst } from '../../constants/const';
export class UpdateShoppingCartModel {
    cardCode: string;
    cartType: number;

    constructor() {
        this.cardCode = StringConst.empty;
        this.cartType = 0;
    }
}
